/**
 * Modelo de objeto de opções de lista de botões selecionaveis;
 * @class InputButtonSelectorConfig
 * @namespace InputButtonSelectorConfig
 */
 export class InputButtonSelectorConfig {
    /**
     * Objeto de configuração base para um input de texto
     * @param {String} id - Id do input
     * @param {String} name - Name para configurações e referencias
     * @param {String} label - Texto a ser exibido na label
     * @param {Array<SelectableButtonOption>} options - Array de objetos opções para listar
     * @param {String} value - Valor Padrão (só utilizado na inicialização)
     * @param {Function} callbackFn - Função a ser executada no callback de mudança de valor
     * @param {Boolean} disabled - Boolean indicando se campo esta desabilitado
     */
    constructor(id, name, label, options = [], value, callbackFn = () => {}, validationFn = null) {
      this.id = id;
      this.name = name;
      this.label = label;
      this.options = options;
      this.value = value;
      this.callbackFn = callbackFn;
      this.validationFn = validationFn;
    }
}

export class SelectableButtonOption {

  /**
   * 
   * @param {String} id - id da opção 
   * @param {String} label - label da opção
   * @param {Boolean} isSelecionada - se opção está selecionada
   * @param {String} value - "value"/"name" da opção
   */
  constructor(id, label, isSelecionada = false, value) {
    this.id = id;
    this.label = label;
    this.isSelecionada = isSelecionada,
    this.value = value;
  }

}